import { render, staticRenderFns } from "./AppRootRoute.vue?vue&type=template&id=15289e7e"
import script from "./AppRootRoute.vue?vue&type=script&lang=ts"
export * from "./AppRootRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports